import {createStore} from "vuex";
import auth from "./modules/auth.module";
import suspendedContracts from "./modules/suspendedContracts.module";

export default createStore({
    modules: {
        auth,
        suspendedContracts,
    },
})